module.exports = __webpack_public_path__ + "static/img/cert-04.a22c76e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert/cert-04.png
// module id = /MCN
// module chunks = 1